const moment = require("moment-timezone")

export const getTimeZones = () => {
  const timeZones = moment.tz.names()
  let timeZoneSelect = []
  for (var i in timeZones) {
    var x = {
      value: timeZones[i],
      label: "GMT" + moment.tz(timeZones[i]).format("Z") + " " + timeZones[i],
    }
    timeZoneSelect.push(x)
  }
  return timeZoneSelect
}

export const getCurrentTimeZone = () => {
  return moment.tz.guess()
}

export const getCurrentDate = () => {
  const newDate = new Date()
  const today = `${newDate.getFullYear()}-${
    newDate.getMonth() < 9
      ? "0" + (newDate.getMonth() + 1)
      : newDate.getMonth() + 1
  }-${newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate()}`

  return today
}

export const mapNotificationFormToApi = (data = {}) => ({
  all_logged_users: data?.audience === "All Logged Users",
  all_users: data?.audience === "All Users",
  business_unit_id: null,
  communication_type: data?.notificationType,
  events:
    data?.audience === "Users in specific experiences"
      ? data?.experienceSearch?.map(event => event.value)
      : [],
  guest_users: data?.audience === "Non-logged in users",
  message: data?.message,
  notification_date: null,
  notification_timezone: null,
  pending_users: false,
  web_link:
    data?.notificationType === "1" && data?.webLink ? data?.webLink : null,
  specific_events: data?.audience === "Users in specific experiences",
  specific_tags: data?.audience === "By tags",
  specific_users: data?.audience === "Individual users",
  subject: data?.subject,
  tags:
    data?.audience === "By tags" ? data?.tagSearch?.map(tag => tag.value) : [],
  title: data?.communicationTitle,
  users:
    data?.audience === "Individual users"
      ? data?.userSearch?.map(user => user.value)
      : [],
})

export const mapCustomEmailFormToApi = (data = {}) => ({
  all_logged_users: false,
  all_users: data?.composeEmail?.includes("All users"),
  business_unit_id: null,
  communication_type: 3,
  events: data?.composeEmail?.includes("Users in specific experiences")
    ? data?.experienceSearch?.map(event => event.value)
    : [],
  guest_users: false,
  message: data?.message,
  notification_date: null,
  notification_timezone: null,
  pending_users: data?.composeEmail?.includes("Pending users"),
  specific_events: data?.composeEmail?.includes(
    "Users in specific experiences"
  ),
  specific_tags: data?.composeEmail?.includes("Tagged users"),
  specific_users: data?.composeEmail?.includes("Individual users"),
  subject: data?.subject,
  tags: data?.composeEmail?.includes("Tagged users")
    ? data?.tagSearch?.map(tag => tag.value)
    : [],
  title: data?.emailName,
  users: data?.composeEmail?.includes("Individual users")
    ? data?.userSearch.map(user => user.value)
    : [],
})

const getComposeEmailValue = apiResponse => {
  const value = []
  if (apiResponse.pending_users) {
    value.push("Pending users")
  }
  if (Object.keys(apiResponse.users).length) {
    value.push("Individual users")
  }
  if (Object.keys(apiResponse.tags).length) {
    value.push("Tagged users")
  }
  if (Object.keys(apiResponse.events).length) {
    value.push("Users in specific experiences")
  }
  if (apiResponse.all_users) {
    value.push("All users in app (active users only)")
  }
  return value
}

export const mapApiToCustomEmail = (apiResponse = {}) => ({
  emailName: apiResponse?.title,

  composeEmail: getComposeEmailValue(apiResponse),
  userSearch: Object.values(apiResponse?.users).map(
    ({ last_name, first_name, id }) => ({
      label: `${first_name} ${last_name}`,
      value: id,
    })
  ),
  tagSearch: Object.values(apiResponse?.tags).map(({ id, tag }) => ({
    label: tag,
    value: id,
  })),
  experienceSearch: Object.values(apiResponse?.events).map(({ id, name }) => ({
    label: name,
    value: id,
  })),
  subject: apiResponse?.subject,
  message: apiResponse?.message,
  date: apiResponse?.notification_date_object?.date
    ? apiResponse?.notification_date_object?.date?.split(" ")[0]
    : null,
  timeType: apiResponse?.notification_date_object?.date
    ? new Date(apiResponse?.notification_date_object?.date)
        .toLocaleTimeString()
        .split(" ")[1]
    : "AM",
  time: apiResponse?.notification_date_object?.date
    ? new Date(apiResponse?.notification_date_object?.date)
        .toLocaleTimeString()
        .split(":")[0]
    : null,
  timeZone: apiResponse?.notification_timezone
    ? apiResponse?.notification_timezone
    : null,
})

const getAudienceValue = apiResponse => {
  if (apiResponse.all_users) {
    return "All Users"
  }
  if (apiResponse.all_logged_users) {
    return "All Logged Users"
  }
  if (Object.keys(apiResponse.users).length) {
    return "Individual users"
  }
  if (Object.keys(apiResponse.tags).length) {
    return "By tags"
  }
  if (Object.keys(apiResponse.events).length) {
    return "Users in specific experiences"
  }
  return "Non-logged in users"
}

export const mapApiToNotification = (apiResponse = {}) => ({
  subject: apiResponse?.subject,
  message: apiResponse?.message,
  webLink: apiResponse?.web_link,

  communicationTitle: apiResponse?.title,
  notificationType: apiResponse?.communication_type === 1 ? "1" : "2",

  audience: getAudienceValue(apiResponse),
  userSearch: Object.values(apiResponse?.users).map(
    ({ last_name, first_name, id }) => ({
      label: `${first_name} ${last_name}`,
      value: id,
    })
  ),
  tagSearch: Object.values(apiResponse?.tags).map(({ id, tag }) => ({
    label: tag,
    value: id,
  })),
  experienceSearch: Object.values(apiResponse?.events).map(({ id, name }) => ({
    label: name,
    value: id,
  })),
  date: apiResponse?.notification_date_object?.date
    ? apiResponse?.notification_date_object?.date?.split(" ")[0]
    : null,
  timeType: apiResponse?.notification_date_object?.date
    ? new Date(apiResponse?.notification_date_object?.date)
        .toLocaleTimeString()
        .split(" ")[1]
    : "AM",
  time: apiResponse?.notification_date_object?.date
    ? new Date(apiResponse?.notification_date_object?.date)
        .toLocaleTimeString()
        .split(":")[0]
    : null,
  timeZone: apiResponse?.notification_timezone
    ? apiResponse?.notification_timezone
    : null,
})
